<template>
    <v-row class="pt-1 mt-0 mb-1 mb-sm-0">
        <v-col cols="12" md="6" class="py-0" >
            <router-link class="pr-4 black--text"
                         :to="{ name: 'product', params: {
                    parentCategory: product.parentCategorySysName,
                    category: product.categorySystemName,
                    sysNameWithId: `${product.systemName}-${product.id}`
                }}"
            >
                <v-row>
                    <v-col cols="3" class="pb-0">
                        <v-img contain :src="imageThumbSrc" v-if="imageSrc"></v-img>
                        <span class="caption" v-if="!imageSrc">Product Image</span>
                    </v-col>
                    <v-col cols="9" class="my-auto py-0">
                        <span class="text-decorated-underline">{{ product.productName }}</span>
                    </v-col>
                </v-row>
            </router-link>
        </v-col>
        <v-col cols="12" md="6">
            <v-row>
                <v-col cols="4" class="py-0">
                    <span class="grey--text">{{$t('price')}}:</span>
                </v-col>
                <v-col cols="4" class="py-0">
                    <span class="grey--text">{{ $t('quantity') }}:</span>
                </v-col>
                <v-col cols="4" class="py-0">
                    <span class="grey--text">{{ $t('total') }}:</span>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="4" class="py-0">
                    <div v-if="totalDiscount > 0" >
                        <span class="caption text-decoration-line-through grey--text text--darken-3">{{ priceWithProductDiscount.toFixed(2) }} {{currency.cyrName.toLowerCase()}}</span>
                    </div>
                    <div>
                        <span :class="{'red--text': totalDiscount > 0, 'grey--text text--darken-3': totalDiscount <= 0}">{{priceWithAllDiscounts.toFixed(2)}} {{currency.cyrName.toLowerCase()}}</span>
                    </div>
                </v-col>
                <v-col cols="4" class="py-0">
                    <span class=" grey--text text--darken-3">{{orderQuantityValue}} {{ product.pack.unitName.toLowerCase() }}</span>
                </v-col>
                <v-col cols="4" class="py-0">
                    <span class="grey--text text--darken-3">{{ discountPrice }} {{ currency.cyrName.toLowerCase() }}</span>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import ThumbsProducts from "../../../app-front/mixins/ThumbsProducts";
import OrderDataProvider from "../../../app-front/mixins/OrderDataProvider";
import OrderCalculator from "../../../app-front/mixins/OrderCalculator";

import numberFormat from "../../../utils/numberFormat";

export default {
    name: "ProductItem",
    mixins: [ThumbsProducts, OrderDataProvider, OrderCalculator],
    props: [ 'product' ],
    data() {
        return {
            calculatedPrice: null,
            currencies: [
                {name: 'uah', priceName: 'priceUah'},
                {name: 'usd', priceName: 'priceUsd'},
                {name: 'eur', priceName: 'priceEur'},
            ],
        }
    },
    computed: {
        inProcessProduct() {
            return this.getProduct(this.product.id, this.product.sellerID)
        },

        /* currency */
        currency() {
            return this.$store.getters.currencies.find(item => item.id === 1);
        },
        /* thumb */
        imageThumbSrc() {
            return (!this.product.images.length) ? '/images/default-product.png' : this.getProductThumb(this.product.images[0], 160);
        },
        imageSrc() {
            return this.product.images[0] || null;
        },

        /* price */
        priceName() {
            return this.currencies.find(item => item.name === 'uah').priceName;
        },
        price() {
            return this.product.price[this.priceName];
        },
        priceWithProductDiscount() {
            return this.price * (1 - this.product.price.discount / 100)
        },
        priceWithAllDiscounts() {
            return this.priceWithProductDiscount * (1 - this.totalDiscount / 100);
        },
        summaryPrice() {
            return this.priceWithAllDiscounts * this.orderQuantityValue;
        },
        discountPrice() {
            const orderData = this.$store.state.order.inProcess.find(item => item.sellerID === this.product.sellerID);
            const price = (orderData === undefined) ? 0 : this.summaryPrice;
            return numberFormat(price, '2', '.', ' ')
        },
        totalDiscount() {
            const orderData = this.inProcessProducts.find(item => item.sellerID === this.product.sellerID);
            return (orderData === undefined) ? 0 : orderData.totalDiscount;
        },

        quantity() {
            return this.inProcessProduct.quantity
        },
        orderQuantityValue() {
            const quantity = this.quantity ? parseFloat(this.quantity) : null;

            if (!quantity) {
                return null;
            }

            const minValue = this.product.pack.minValue;
            const value = this.product.pack.value;
            let quantityWeight = value * quantity;

            if (minValue > 0) {
                quantityWeight *= minValue;
            }

            return quantityWeight
        },
    },
    created() {
        this.$emit('order-change', {
            id: this.product.id,
            sellerID: this.product.sellerID,
            selfShipment: this.product.selfShipment,
            price: this.price,
            discount: this.product.price.discount,
            quantity: this.quantity,
            calculatedPrice: this.priceWithProductDiscount * this.orderQuantityValue,
        })
    }
}
</script>

<style scoped>

</style>
